<!-- Menus are wrapped in ng-template for lazy loading menu content -->

<!-- Menu trigger -->
<button mat-icon-button [matMenuTriggerFor]="moduleOptionsMenu" [disabled]="disabled">
  <mat-icon>more_vert</mat-icon>
</button>

<!-- Main menu -->
<mat-menu #moduleOptionsMenu="matMenu">
  <ng-template matMenuContent>

    <button mat-menu-item 
      *ngIf="config.addSubmodule"
      (click)="addSubmodule(module)"
      [disabled]="!authService.canCreate('submodule')">
      <mat-icon>add</mat-icon>
      {{ 'submoduleAdd' | translate }}
    </button>

    <mat-divider
      *ngIf="config.addSubmodule && (config.setStatus || config.assignTo)">
    </mat-divider>

    <button mat-menu-item 
      *ngIf="config.setStatus"
      [matMenuTriggerFor]="editStatusSubmenu"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>label</mat-icon>
      {{ 'changestatus' | translate }}
    </button>

    <button mat-menu-item
      *ngIf="config.assignTo"
      [matMenuTriggerFor]="assignToSubmenu"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>face</mat-icon>
      {{ 'assignto' | translate }}
    </button>

    <mat-divider
      *ngIf="config.addSubmodule && config.delete">
    </mat-divider>

    <button mat-menu-item
      *ngIf="config.delete"
      (click)="delete(module)"
      [disabled]="!authService.canDelete('module')">
      <mat-icon>delete</mat-icon>
      {{ 'delete' | translate: 'plural' }}
    </button>

  </ng-template>
</mat-menu>


<!-- Submenu: Edit status -->
<mat-menu #editStatusSubmenu="matMenu">
  <ng-template matMenuContent>
      <button mat-menu-item *ngFor="let status of statuses"
      (click)="setStatus(module, status)">
        <mat-icon [style.color]="status.color">label</mat-icon>
        {{ status.displayName }}
      </button>
  </ng-template>
</mat-menu>

<!-- Submenu: Assign to -->
<mat-menu #assignToSubmenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="assignToUser(module, -1)" [style.paddingLeft]="'70px'">
      {{ 'notassigned' | translate }}
    </button>
    <button mat-menu-item *ngFor="let user of userService.user$ | async"
    (click)="assignToUser(module, user)">
      <sg2-user-icon [user]="user"></sg2-user-icon>
      {{ user.fullName }}
    </button>
  </ng-template>
</mat-menu>
